import React from 'react'

import StepOneImage from 'src/features/business/referrals/assets/tutorial/step1-browse.png'
import StepTwoImage from 'src/features/business/referrals/assets/tutorial/step2-notify.png'
import StepThreeImage from 'src/features/business/referrals/assets/tutorial/step3-chat.png'
import StepFourImage from 'src/features/business/referrals/assets/tutorial/step4-refer.png'
import { Button } from 'src/shared/components/ui/buttons/button'
import type { CarouselApi } from 'src/shared/components/ui/miscellaneous/carousel'
import { Carousel, CarouselContent, CarouselItem } from 'src/shared/components/ui/miscellaneous/carousel'
import { ResponsivePopup } from 'src/shared/components/ui/popups/responsive-popup'
import { useUpdateUserTutorials } from 'src/shared/features/users/api/preferences/use-update-user-preferences'
import { useUserTutorials } from 'src/shared/features/users/api/preferences/use-user-tutorials'

export const SendReferralTutorial = () => {
  const { data: tutorials } = useUserTutorials()
  const updateTutorials = useUpdateUserTutorials()
  const [isLastSlide, setIsLastSlide] = React.useState(false)
  const [api, setApi] = React.useState<CarouselApi>()
  // const [currentSlide, setCurrentSlide] = React.useState(0)
  const [open, setOpen] = React.useState(true)

  const showTutorial = tutorials ? !tutorials.sendReferralTutorial : false

  React.useEffect(() => {
    if (!api) return

    api.on('select', () => {
      const lastSlideIndex = api.scrollSnapList().length - 1
      setIsLastSlide(api.selectedScrollSnap() === lastSlideIndex)
      // setCurrentSlide(api.selectedScrollSnap())
    })
  }, [api])

  const handleNext = () => {
    if (isLastSlide) {
      setOpen(false)
    } else {
      api?.scrollNext()
    }
  }

  const handleSkip = () => {
    setOpen(false)
    updateTutorials.mutate({
      sendReferralTutorial: true,
    })
  }

  if (!showTutorial) return null

  return (
    <ResponsivePopup open={open} onOpenChange={setOpen} trigger={<div />} hideHeader dark>
      <div className="flex flex-col items-center justify-between gap-3 p-2">
        <h1 className="text-3xl font-bold">Sending Referrals</h1>

        <Carousel
          className="w-[90%]"
          opts={{
            loop: false,
          }}
          setApi={setApi}
        >
          <CarouselContent className="-ml-0 flex items-center gap-4">
            <CarouselItem className="px-0">
              <img src={StepOneImage} alt="Browse" className="h-auto w-full rounded-lg" />
            </CarouselItem>
            <CarouselItem className="px-0">
              <img src={StepTwoImage} alt="Notifications" className="h-auto w-full rounded-lg" />
            </CarouselItem>
            <CarouselItem className="px-0">
              <img src={StepThreeImage} alt="Chat" className="h-auto w-full rounded-lg" />
            </CarouselItem>
            <CarouselItem className="px-0">
              <img src={StepFourImage} alt="Refer" className="h-auto w-full rounded-lg" />
            </CarouselItem>
          </CarouselContent>
        </Carousel>
        <div className="flex w-full flex-col">
          <Button variant="secondary" onClick={handleNext} className="w-full">
            {isLastSlide ? "Let's Go!" : 'Next'}
          </Button>
          <Button variant="link" onClick={handleSkip} className="text-center text-primary-foreground">
            Skip Next Time
          </Button>
        </div>
      </div>
    </ResponsivePopup>
  )
}
